var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { FactoryComponent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import useDesign from '../../../hooks/useDesign';
import { BaseInput } from '../BaseInput';
import { Formatter } from '../Formatter';
export var RangeInputComponent = forwardRef(function (_a, ref) {
    var _b;
    var design = _a.design, components = _a.components, schema = _a.schema, value = _a.value, props = __rest(_a, ["design", "components", "schema", "value"]);
    var config = useDesign(components.text).config;
    return (_jsxs(FactoryComponent, __assign({ schema: schema }, { children: [_jsx(BaseInput, __assign({ ref: ref, design: components.input, type: "range" }, props)), _jsx(Formatter, { design: components.text, values: (_b = {}, _b[config.pick] = value, _b) })] })));
});
export var RangeInput = withDesign(RangeInputComponent);
RangeInput.displayName = 'RangeInput';
